import { useUserProvider } from "./provider";
import {
  Button,
  IconButton,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Text,
} from "@chakra-ui/react";
import "./index.css";
import { BsSendFill } from "react-icons/bs";
import { TbHeart, TbMailFilled } from "react-icons/tb";
import { useReportManager } from "../../wrappers/report";
import { BiDotsVertical } from "react-icons/bi";
import { IoBug } from "react-icons/io5";
/**
 *
 * @param {import("@chakra-ui/react").ButtonProps & import("./props").UserProps} props
 * @returns
 */
const OptionsButton = (props) => {
  const user = useUserProvider();
  const { triggerReportProfile } = useReportManager();

  return (
    <Menu placement="bottom-end">
      <MenuButton
        as={IconButton}
        icon={<BiDotsVertical />}
        variant={"nav"}
        size="sm"
        bg="#2d2d2d"
      />
      <MenuList>
        <MenuItem color="red.400" onClick={() => triggerReportProfile(user)}>
          <IoBug />
          <Text>Report Profile</Text>
        </MenuItem>
      </MenuList>
    </Menu>
  );
};

export default OptionsButton;
